"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accordion_1 = require("../modules/accordion");
var get_element_1 = require("../utils/get_element");
var IDS = {
    SYMBOL_MARK_ACCORDION: 'js-symbol-mark-accordion',
    LASER_CLASS_ACCORDION: 'js-laser-class-accordion',
};
var initSymbolMarkAccordion = function () {
    var container = (0, get_element_1.getElementById)(IDS.SYMBOL_MARK_ACCORDION);
    new accordion_1.Accordion(container);
};
var initLaserClassAccordion = function () {
    var container = (0, get_element_1.getElementById)(IDS.LASER_CLASS_ACCORDION);
    new accordion_1.Accordion(container);
};
initSymbolMarkAccordion();
initLaserClassAccordion();
